import { Component, OnInit, ViewChild} from '@angular/core';
import { MatTableDataSource, MatDialog, MatPaginator, MatSort, Sort } from '@angular/material';
import { WebConstants } from 'src/app/util/web.constants';
import { ToastrService } from 'ngx-toastr';
import { TokenStorage } from 'src/app/util/token.storage';
import { PaymentDetailSearchService } from 'src/app/services/payment-detail-search';
import { first } from 'rxjs/operators';
import { ExcelExportDataService } from 'src/app/excelService/excel-export-data.service';

@Component({
  selector: 'app-numplate-permit-search',
  templateUrl: './numplate-permit-search.component.html',
  styleUrls: ['./numplate-permit-search.component.scss']
})
export class NumplatePermitSearchComponent implements OnInit {

  public dataSource = new MatTableDataSource();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  public displayedColumns: string[] = [
    'data.numberPlate',
    'data.zoneNumber',
    'data.startTime',
    'data.endTime',
    'data.paymentServiceName'
  ];

  public data: any;
  public title: string = WebConstants.MENU_NAMES.PERMIT_DETAIL_SEARCH;
  public search: any = "";

  constructor(
    public toastrService: ToastrService,
    public paymentDetailService: PaymentDetailSearchService,
    public excelExportDataService: ExcelExportDataService
  ) { }

  getProperty = (obj, path) => (
    path.split('.').reduce((o, p) => o && o[p], obj)
  )

  findPermitDetailByLP(licensePlate: any){
    this.paymentDetailService.getPermitDetailByLP(licensePlate.toUpperCase()).pipe(first()).subscribe(response => {
     if(response && response.code == WebConstants.STATUS.CODE_SUCCESS){
      this.data = response.data;
      this.dataSource = new MatTableDataSource<unknown>(this.data);
      this.dataSource.sortingDataAccessor = (obj, property) => this.getProperty(obj, property);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
     } 
     else{
      this.toastrService.error(response.value, "Failed To Load Data!")
     }
    });
  }


  excelSheetDownload() {
    let dataForExcel = [];

    this.data.forEach((row: any) => {
      //console.log(row);
      let rowData: any = [
        row.data.numberPlate==null? row.data.lpn:row.data.numberPlate,
        row.data.zoneName==null? row.data.zoneNumber:row.data.zoneName,
        new Date(row.data.startTime).toLocaleString(),
        new Date(row.data.endTime).toLocaleString(),
        row.data.paymentServiceName
      ]
      dataForExcel.push(rowData);
    });

    let reportData = {
      title: this.title,
      data: dataForExcel,
      headers: ['License Plate', 'Zone', 'Start Time','End Time','Payment Service Provider']
    };

    this.excelExportDataService.exportExcel(reportData)
  }

  ngOnInit() {
  }

}

